<div class="overlay">
    <div class="playgrounds-wrapper">
      <div class="d-lg-flex justify-content-between align-items-center mb-3">
        <h1>Select Playgrounasdadsdasadssdasdad</h1>
        <input 
          type="text"
          placeholder="Search for Playground"
          class="form-control w-lg-50"
          (input)="searchBusinesses($event)" />
      </div>
      <div class="d-flex justify-content-between flex-wrap">
        <div 
          *ngFor="let business of filteredBusinesses" 
          class="playground-card"
          (click)="selectBusiness(business)">
          <div>
            <img
              [src]="business.businessImageUrl"
              alt="{{ business.name }}"
              class="img-fluid"
            />
          </div>
          <h3>{{ business.name }}</h3>
        </div>
      </div>
      <button class="btn btn-secondary mt-3" (click)="close()">Cancel</button>
    </div>
  </div> 